import { Breadcrumbs } from "@frends/ui-components/react";

export default Breadcrumbs;
